import {
    Document,
    Page,
    View,
    Text,
    Image,
    StyleSheet,
    Font,
} from '@react-pdf/renderer';

import NotoSansDevanagariR from '../font/NotoSansDevanagari-Regular.ttf'
import NotoSansDevanagariB from '../font/NotoSansDevanagari-Bold.ttf'


Font.register({
    family: 'NotoSansDevanagari',
    fonts: [
        {
            src: NotoSansDevanagariR,
            fontWeight: 'normal',
        },
        {
            src: NotoSansDevanagariB,
            fontWeight: 'bold',
        },
    ],
});

const styles = StyleSheet.create({
    page: {
        fontFamily: 'NotoSansDevanagari',
        padding: 20,
    },
    cardRow: {
        flexDirection: 'row',
        justifyContent: 'center',
        gap: 20,
    },
    card: {
        width: 241, // 85mm = 241pt
        height: 156, // 55mm = 156pt
        border: '1pt solid #333',
        /* borderRadius: 16, */
        padding: 10,
        boxSizing: 'border-box',
        backgroundColor: '#fff',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        boxShadow: '2px 2px 6px rgba(0, 0, 0, 0.2)',
    },
    front: {
        backgroundColor: '#ffffff'
    },
    back: {
        backgroundColor: '#ffffff',
    },
    header: {
        textAlign: 'center',
        marginBottom: 4,
    },
    logo: {
        height: 20,
        marginBottom: 4,
        alignSelf: 'center',
    },
    title: {
        fontSize: 12,
        fontWeight: 'bold',
        color: '#05a012',
        textAlign: 'center',
        marginBottom: 4,
    },
    photoRow: {
        flexDirection: 'row',
        marginBottom: 6,
    },
    farmerPhoto: {
        width: 60,
        height: 70,
        objectFit: 'cover',
        borderRadius: 8,
        border: '1pt solid #333',
    },
    infoBlock: {
        marginLeft: 8,
        flexGrow: 1,
        justifyContent: 'space-between',
        fontWeight: 'bold'
    },
    infoText: {
        fontSize: 8,
        marginBottom: 2,
    },
    infoTextBack: {
        fontSize: 7,
        marginBottom: 1,
    },
    farmerIdText: {
        fontSize: 14,
        fontWeight: 'bold',
        letterSpacing: 1,
        textAlign: 'center',
        marginTop: 4,
        fontFamily: 'Helvetica-Bold'
    },
    textShadow: {
        position: 'absolute',
        top: 0,
        left: 1, // Adjust the shadow's horizontal position
        zIndex: -1, // Place the shadow text behind
        color: 'black', // Shadow color
        opacity: 0.5,  // Adjust shadow opacity for a thicker look
    },
    note: {
        fontSize: 7,
        color: 'black',
        textAlign: 'center',
        marginTop: 10,
    },
    headerRow: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: 8,
    },

    logoInline: {
        width: 60,
        height: 20,
        marginRight: 6,
    },

    logoRight: {
        width: 15,
        height: 15,
        marginRight: 10,
        flexDirection: 'row'
    },

    titleInline: {
        fontSize: 14,
        fontWeight: 'bold',
        color: '#05a012',
    },
    margin_bottom: {
        marginBottom: 4
    },
    background: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: -1,
        borderRadius: 16,
    },

    photoRowBack: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        marginBottom: 6,
    },

    infoBlockBack: {
        width: '70%', // ⬅️ Explicit width
        justifyContent: 'space-between',
    },

    qrImage: {
        width: 60,
        height: 60,
        objectFit: 'cover',
        borderRadius: 8,
    },

    sectionTitle: {
        fontSize: 8,
        fontWeight: 'bold',
        marginBottom: 1,
    },
    /*  villageBlock: {
         marginBottom: 1,
         marginLeft: 7,
     }, */
    villageName: {
        fontSize: 7,
        marginBottom: 1,
    },

    plotList: {
        fontSize: 7,
        /* marginLeft: 10, */
    },

    genterStyle: {
        fontWeight: "normal"
    },
    downloadDate: {
        position: 'absolute',
        right: -8,
        top: '50%',
        transform: 'rotate(90deg)',
        transformOrigin: 'center',
        fontSize: 6,
        color: '#666',
        fontWeight: 'bold',
        width: 80,
        textAlign: 'center',
    },
    watermark: {
        position: 'absolute',
        top: '80%',
        left: '50%',
        transform: 'translate(-50%, -50%) rotate(-30deg)',
        fontSize: 8,
        color: 'black',
        opacity: 0.3,
        zIndex: 1,
        fontWeight: 'bold',
    },

    watermark1: {
        position: 'absolute',
        top: '70%',
        left: '100%',
        transform: 'translate(-50%, -50%) rotate(-90deg)',
        fontSize: 8,
        color: 'black',
        opacity: 0.1,
        zIndex: 1,
        fontWeight: 'bold',
    },
    farmerIdImageBg: {
        position: 'absolute',
        bottom: 0,
        right: 3,
        width: 60, // Adjust as needed
        height: 70, // Adjust as needed
        opacity: 1,  // Optional: lower opacity to keep it in background
        zIndex: -1,
    },
    /*  watermark2: 
         position: 'absolute',
         top: '90%',
         left: '4%',
         transform: 'translate(-50%, -50%) rotate(90deg)',
         fontSize: 8,
         color: 'black',
         opacity: 0.1,
         zIndex: 1,
         fontWeight: 'bold',
     },
 
     watermark3: {
         position: 'absolute',
         top: '90%',
         left: '50%',
         transform: 'translate(-50%, -50%) rotate(0deg)',
         fontSize: 8,
         color: 'black',
         opacity: 0.1,
         zIndex: 1,
         fontWeight: 'bold',
     } */

});

const FarmerCardPDF = ({ farmer, logo, qrImage, emblem_of_india, indian_flag, farmerIdImage }) => (
    <Document>
        <Page size="A4" style={styles.page}>

            <View style={styles.cardRow}>
                {/* Front */}

                <View style={[styles.card, styles.front]}>
                    <Text style={styles.watermark}>PERSONAL USE ONLY</Text>
                    {/*  <Text style={styles.watermark1}>PERSONAL USE ONLY</Text> */}
                    {/*  <Text style={styles.watermark2}>PERSONAL USE ONLY</Text> */}


                    {/* <Image
                        src="/src/img/testDemo.png" // Use base64 or a local asset in Node environments
                        style={styles.background}
                    /> */}
                    <View style={styles.headerRow}>
                        <Image src={emblem_of_india} style={[styles.logoRight, styles.margin_bottom]} />
                        <Image src={logo} style={[styles.logoInline, styles.margin_bottom]} />
                        <Image src={indian_flag} style={[styles.logoInline, styles.margin_bottom]} />
                    </View>
                    <View style={styles.photoRow}>
                        <Image src={farmer.photograph} style={styles.farmerPhoto} />
                        <View style={styles.infoBlock}>
                            <Text style={styles.infoText}>Name: {farmer.nameEn}</Text>
                            <Text style={styles.infoText}>नाव : {farmer.nameMr}</Text>
                            <Text style={styles.infoText}>DOB: {farmer.dob}</Text>
                            <Text style={styles.infoText}>Gender: <Text style={styles.genterStyle}>{farmer.gender}</Text></Text>

                            <Text style={styles.infoText}>
                                Aadhar No:{' '}
                                {atob(farmer.aadharNo)
                                    /*  .replace(/^(\d{2})\d+(?=\d{4}$)/, '$1******') */
                                    .replace(/(.{4})/g, '$1 ')
                                    .trim()}
                            </Text>

                            <Text style={styles.infoText}>
                                Mobile: {farmer.mobileNumber/* ?.replace(/^(\d{2})\d+(?=\d{3}$)/, '$1*****') */}
                            </Text>
                        </View>
                    </View>
                    <Text style={[{ ...styles.farmerIdText, marginLeft: 20, textAlign: 'left' }]}>
                        {farmer.centralId?.replace(/(.{4})/g, '$1 ').trim()}
                    </Text>
                    <Image src={farmerIdImage} style={styles.farmerIdImageBg} />

                </View>

                {/* Back */}
                <View style={[styles.card, styles.back]}>
                    {/* <Text style={styles.watermark}>PERSONAL USE ONLY</Text> */}
                    <View style={styles.headerRow}>
                        <Image src={emblem_of_india} style={[styles.logoRight, styles.margin_bottom]} />
                        <Image src={logo} style={[styles.logoInline, styles.margin_bottom]} />
                        <Image src={indian_flag} style={[styles.logoInline, styles.margin_bottom]} />
                    </View>
                    <View style={styles.photoRowBack}>

                        <View style={styles.infoBlockBack}>
                            <Text style={styles.infoTextBack}>पत्ता : {farmer.addressMr}</Text>
                            {Object.entries(farmer?.landDetails).map(([village, plots]) => (
                                <View key={village} style={styles.villageBlock}>
                                    <Text style={styles.villageName}>{village} ({farmer?.khataNumbers?.[village].join(", ")}) :

                                        {plots.map((plot, index) => (
                                            <Text key={index}>
                                                {plot}
                                                {index !== plots.length - 1 ? ', ' : ''}
                                            </Text>
                                        ))}
                                    </Text>

                                </View>
                            ))}

                            <Text style={styles.infoTextBack}>Total Area : {farmer?.totalArea.toFixed(2)} Hectare</Text>
                        </View>
                        <Image src={qrImage} style={styles.qrImage} />
                    </View>



                    <Text style={styles.farmerIdText}>
                        {farmer.centralId?.replace(/(.{4})/g, '$1 ').trim()}
                    </Text>
                    <Text style={styles.note}>
                        हे कार्ड फक्त वैयक्तिक वापरासाठी तयार करण्यात आलेले आहे.
                    </Text>

                </View>
            </View>

            <View style={{ marginTop: 20, padding: 10 }}>
                <Text style={{ fontSize: 8, textAlign: 'justify', lineHeight: 1.2 }}>
                    Disclaimer -ओळखपत्रामध्ये वापरलेले भारताचे राष्ट्रीय चिन्ह (National Emblem of India) "राजमुद्रा", AgriSatck या महाराष्ट्र शासनाच्या प्रोजेक्ट चा लोगो आणि राष्टीय ध्वज हे फक्त कार्ड आकर्षक दिसावे या या एकाच उद्देशाने वापरलेले आहे. सदरील कार्ड हे कोणत्याही शासकीय / निमशासकीय कामामध्ये ओळखपत्र म्हणून वापरता येणार नाही. या कार्ड मध्ये शेतकऱ्याची माहिती जसे की, नाव , जन्म तारीख , आधार नंबर , मोबाइल नंबर, जमिनीची शिवारानुसार माहिती (खाते क्रमांक , सर्वे नंबर ) आहे .
                    हे कार्ड फक्त शेतकऱ्यांना त्यांचा फार्मर Id लक्ष्यात राहावा या हेतूने तयार केले आहेत.
                </Text>
            </View>
        </Page>
    </Document>
);

export default FarmerCardPDF;
